import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import gs from '../../styles/style';
var ListLimiter = function (_a) {
    var items = _a.items, _b = _a.separator, separator = _b === void 0 ? ', ' : _b, _c = _a.limit, limit = _c === void 0 ? 3 : _c;
    var t = useTranslation()[0];
    var initialItems = items.slice(0, limit);
    var restItems = items.slice(limit);
    var _d = useState(false), expand = _d[0], setExpand = _d[1];
    return (React.createElement(React.Fragment, null,
        initialItems.map(function (item, index) { return (React.createElement(Fragment, { key: index },
            index > 0 && separator,
            item)); }),
        restItems.length > 0 && !expand && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: gs('text-muted') }, "\u2026"),
            ' ',
            React.createElement("a", { onClick: function () { return setExpand(true); } }, " + ".concat(restItems.length)))),
        expand && restItems.map(function (item, index) { return (React.createElement(Fragment, { key: index },
            separator,
            item)); }),
        restItems.length > 0 && expand && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: gs('text-muted') }, " \u2022 "),
            React.createElement("a", { onClick: function () { return setExpand(false); } }, t('less'))))));
};
export default ListLimiter;
